import { DebouncedFunction, StringUtil } from "@mcleod/core";
import { Label } from "@mcleod/components";
import { AutogenLayoutLiveDemoLinkEmailPhone } from "./autogen/AutogenLayoutLiveDemoLinkEmailPhone";

export class LiveDemoLinkEmailPhone extends AutogenLayoutLiveDemoLinkEmailPhone {
    private panelHeaderExpanded = true;
    private textboxEmailChangeListener = DebouncedFunction.create(this.syncEmailLabel, 300);
    private textboxLinkChangeListener = DebouncedFunction.create(this.syncLinkLabel, 300);
    private textboxPhoneChangeListener = DebouncedFunction.create(this.syncPhoneLabel, 300);
    

    override onLoad() {
        this.addBulletsToInstructionLabels();
    }

    private addBulletsToInstructionLabels() {
        this.components.forEach(component => {
            if (component instanceof Label && component.id.startsWith("labelInstructions")) {
                component.text = "\u2022 " + component.text;
            }
        });
    }

    buttonChevronOnClick() {
        if (this.panelHeaderExpanded) {
            this.collapsePanelHeader();
        } else {
            this.expandPanelHeader();
        }
    }

    public collapsePanelHeader() {
        this.panelHeaderExpanded = false;
        this.setChevronImageRotation();
        this.panelHeader.collapse({ speed: 400 });
    }

    public async expandPanelHeader() {
        this.panelHeaderExpanded = true;
        this.setChevronImageRotation();
        this.panelHeader.expand({ speed: 400 });
    }

    private setChevronImageRotation() {
        this.buttonChevron.imageRotation = this.panelHeaderExpanded ? 0 : 90;
    }

    textboxLinkOnChange() {
        this.textboxLinkChangeListener();
    }

    textboxLinkOptionalTextOnChange() {
        this.textboxLinkChangeListener();
    }

    private syncLinkLabel() {
        const link = this.textboxLink.text;
        const optionalLinkText = this.textboxLinkOptionalText.text;
        this.labelLink.text = !StringUtil.isEmptyString(optionalLinkText) ? optionalLinkText : link;
        this.labelLink.link = link;
    }

    textboxEmailOnChange() {
        this.textboxEmailChangeListener();
    }

    private syncEmailLabel() {
        this.labelEmail.text = this.textboxEmail.text;
    }

    textboxPhoneOnChange() {
        this.textboxPhoneChangeListener();
    }

    private syncPhoneLabel() {
        this.labelPhone.text = this.textboxPhone.text;
    }
}
